/** סדר ברירת מחדל – דף הבית */
export const defaultSuccessStoryImages = [
  '/s1.jpg',
  '/s2.jpeg',
  '/s3.jpg',
  '/s4.jpeg',
  '/s7.jpg',
  '/s10.jpeg',
  '/s8.jpeg',
  '/s9.jpeg',
];

/** סדר תמונות לדף חדלות פירעון – ערכו כאן את הסדר הרצוי */
export const insolvencySuccessStoryImages = [
  '/1hadlot.jpeg',
  '/2-1.jpeg',
  '/3-4.jpeg',
  '/4.jpeg',
  '/5.jpeg',
  '/6.jpeg',
  '/7.jpeg',

];

/** סדר תמונות לדף הוצאה לפועל – ערכו כאן את הסדר הרצוי */
export const executionSuccessStoryImages = [
  '/2-1.jpeg',
  '/2hozaa.jpeg',
  '/3hozaa.jpeg',
  '/3-4.jpeg',
  '/5.jpeg',
  '/6.jpeg',

];
